const ROLE_ADMIN = "ROLE_ADMIN"
const ROLE_MANAGER = "ROLE_MANAGER"
const ROLE_DOCTOR = "ROLE_DOCTOR"

export { ROLE_ADMIN, ROLE_MANAGER, ROLE_DOCTOR }
